export const resourceCategoryOptions = [
    { label: "resource.data.sheet", value: "data-sheet" },
    { label: "resource.customer.review", value: "customer-review" },
    { label: "resource.case.study", value: "case-study" },
    { label: "resource.whitepaper", value: "whitepaper" },
    { label: "resource.webinar", value: "webinar" },
    { label: "resource.custom.guide", value: "custom-guide" },
]

export const resourceCategoryOptionsKey = {
    "data-sheet": "resource.data.sheet",// 数据表
    "customer-review": "resource.customer.review",// 客户评价
    "case-study": "resource.case.study",//案例研究
    "whitepaper": "resource.whitepaper",//白皮书
    "webinar": "resource.webinar",// 网络研讨会
    "custom-guide": "resource.custom.guide",// 定制指南
}

export const industryOptionNew = [
    { label: "resource.industry.high.end.manufacturing", value: '4' },
    { label: "resource.industry.ai.computing", value: '8' },
    { label: "resource.industry.consumer.goods", value: '2' },
    { label: "resource.industry.mechanical.equipment", value: '6' },
    { label: "resource.industry.heavy.manufacturing", value: '7' },
    { label: "resource.industry.automotive", value: '1' },
    { label: "resource.industry.internet", value: '9' },
    { label: "resource.industry.semiconductor", value: '5' },
    { label: "resource.industry.communication", value: '3' },
    { label: "resource.industry.financial.investment", value: '10' },
    { label: "resource.industry.financing.guarantee", value: '11' },
    { label: "resource.industry.financial.leasing", value: '12' },
    { label: "resource.industry.insurance", value: '13' },
    { label: "resource.industry.wealth.management", value: '14' },
    { label: "resource.industry.medical.devices", value: '15' },
    { label: "resource.industry.pharmaceutical", value: '16' },
    { label: "resource.industry.health.elderly.care", value: '17' },
    { label: "resource.industry.education.training", value: '18' },
    { label: "resource.industry.k12", value: '19' },
    { label: "resource.industry.energy.chemical", value: '20' },
    { label: "resource.industry.nonferrous.metals", value: '21' },
    { label: "resource.industry.steel", value: '22' },
    { label: "resource.industry.park.real.estate", value: '23' },
    { label: "resource.industry.lawyer", value: '24' },
    { label: "resource.industry.enterprise.service", value: '25' },
    { label: "resource.industry.media.tourism", value: '26' },
    { label: "resource.industry.medical.service.solution", value: '27' },
    { label: "resource.industry.other", value: '28' },
    { label: "resource.industry.logistics", value: '29' },
    { label: "resource.industry.ecommerce", value: '30' },
    { label: "resource.industry.system.integration", value: '31' },
]
export const industryOptionNew2 = {
    '4': "resource.industry.high.end.manufacturing",//高端制造
    '8': "resource.industry.ai.computing",//AI算力
    '2': "resource.industry.consumer.goods",//消费品
    '6': "resource.industry.mechanical.equipment",//机械设备
    '7': "resource.industry.heavy.manufacturing",//重工制造
    '1': "resource.industry.automotive",//汽车
    '9': "resource.industry.internet",//互联网
    '5': "resource.industry.semiconductor",//半导体芯片
    '3': "resource.industry.communication",//通信
    '10': "resource.industry.financial.investment",//金融投资
    '11': "resource.industry.financing.guarantee",//融资担保
    '12': "resource.industry.financial.leasing",//融资租赁
    '13': "resource.industry.insurance",//保险
    '14': "resource.industry.wealth.management",//财富管理
    '15': "resource.industry.medical.devices",//医疗器械/IVD
    '16': "resource.industry.pharmaceutical",//医药
    '17': "resource.industry.health.elderly.care",//健康养老
    '18': "resource.industry.education.training",//教育培训
    '19': "resource.industry.k12",//K12
    '20': "resource.industry.energy.chemical",//能源/化工
    '21': "resource.industry.nonferrous.metals",//有色金属
    '22': "resource.industry.steel",//钢铁
    '23': "resource.industry.park.real.estate",//园区地产
    '24': "resource.industry.lawyer",//法律
    '25': "resource.industry.enterprise.service",//企业服务
    '26': "resource.industry.media.tourism",//媒体旅游
    '27': "resource.industry.medical.service.solution",//医疗服务行业方案
    '28': "resource.industry.other",//其他
    '29': "resource.industry.logistics",//物流
    '30': "resource.industry.ecommerce",//电子商务
    '31': "resource.industry.system.integration",//系统集成
}
export const solutionsOption = {
    销售云: "resource.solutions.sales.cloud",
    市场云: "resource.solutions.marketing.cloud",
    服务云: "resource.solutions.customer.service.cloud",
    // 办公云: "resource.solutions.office.cloud",
    // 人力资源: "resource.solutions.hr",
    // 项目管理: "resource.solutions.project.management",
    现场服务云: "resource.solutions.field.service.cloud",
    项目云: "resource.solutions.project.cloud",
    伙伴云: "resource.solutions.partner.cloud",
    商务云: "resource.solutions.business.cloud",
    利润云: "resource.solutions.profit.cloud",
    平台云: "resource.solutions.platform.cloud",
    其他: "resource.solutions.other",
}

// 所属行业选项
export const industryOption = {
    高端制造: "resource.industry.high.end.manufacturing",
    'AI、算力': "resource.industry.ai.computing",
    消费品: "resource.industry.consumer.goods",
    机械设备: "resource.industry.mechanical.equipment",
    重工制造: "resource.industry.heavy.manufacturing",
    汽车: "resource.industry.automotive",
    互联网: "resource.industry.internet",
    半导体芯片: "resource.industry.semiconductor",
    通信: "resource.industry.communication",
    金融投资: "resource.industry.financial.investment",
    融资担保: "resource.industry.financing.guarantee",
    融资租赁: "resource.industry.financial.leasing",
    保险: "resource.industry.insurance",
    财富管理: "resource.industry.wealth.management",
    '医疗器械/IVD': "resource.industry.medical.devices",
    医药: "resource.industry.pharmaceutical",
    健康养老: "resource.industry.health.elderly.care",
    教育培训: "resource.industry.education.training",
    K12: "resource.industry.k12",
    能源化工: "resource.industry.energy.chemical",
    有色金属: "resource.industry.nonferrous.metals",
    钢铁: "resource.industry.steel",
    园区地产: "resource.industry.park.real.estate",
    律师: "resource.industry.lawyer",
    企业服务: "resource.industry.enterprise.service",
    媒体旅游: "resource.industry.media.tourism",
    医疗服务行业方案: "resource.industry.medical.service.solution",
    其他: "resource.industry.other",
    物流行业: "resource.industry.logistics",
    电子商务: "resource.industry.ecommerce",
    系统集成: "resource.industry.system.integration",
}

// 选择资源选项
export const categoryAppOption = {
    0: "resource.category.custom.component",// 自定义组件
    1: "resource.category.custom.class",// 自定义类
    2: "resource.category.scheduled.class",// 定时类
    3: "resource.category.trigger",// 触发器
    4: "resource.category.client.script",// 客户端脚本
}